<template>
  <div class="content-8__controlbar__item">
    <div class="c8-select">
      <div class="c8-select__content">
        <div
          v-show="showPresentMissing"
          class="checkbox c8-select__content__item"
          :class="{ active: present.presentMissing }"
          @click="present.presentMissing = !present.presentMissing"
        >
          <i class="checkbox__select"></i>
          <label class="checkbox__label" for="">遗漏</label>
        </div>
        <div
          v-show="showPresentLine"
          class="checkbox c8-select__content__item"
          :class="{ active: present.presentLine }"
          @click="present.presentLine = !present.presentLine"
        >
          <i class="checkbox__select"></i>
          <label class="checkbox__label" for="">折线</label>
        </div>
        <div
          v-show="showPresentLineMissingLayer"
          class="checkbox c8-select__content__item"
          :class="{ active: present.presentLineMissingLayer }"
          @click="present.presentLineMissingLayer = !present.presentLineMissingLayer"
        >
          <i class="checkbox__select"></i>
          <label class="checkbox__label" for="">遗漏分层</label>
        </div>
        <div
          v-show="showPresentLineDivided"
          class="checkbox c8-select__content__item"
          :class="{ active: present.presentLineDivided }"
          @click="present.presentLineDivided = !present.presentLineDivided"
        >
          <i class="checkbox__select"></i>
          <label class="checkbox__label" for="">分隔线</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PresentSelector',
  props: {
    presentMissing: {
      type: Boolean,
      default: true
    },
    presentLine: {
      type: Boolean,
      default: true
    },
    presentLineMissingLayer: {
      type: Boolean,
      default: false
    },
    presentLineDivided: {
      type: Boolean,
      default: false
    },

    options: {
      type: Array,
      default: () => ['presentMissing', 'presentLine', 'presentLineMissingLayer', 'presentLineDivided']
    }
  },
  data() {
    return {
      showPresentMissing: false,
      showPresentLine: false,
      showPresentLineMissingLayer: false,
      showPresentLineDivided: false,
      present: {
        presentMissing: true,
        presentLine: true,
        presentLineMissingLayer: false,
        presentLineDivided: false
      }
    }
  },
  watch: {
    present: {
      handler(present) {
        this.$emit('changePresent', Object.assign({}, present))
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.options.forEach((option) => {
      switch (option) {
        case 'presentMissing':
          this.showPresentMissing = true
          break
        case 'presentLine':
          this.showPresentLine = true
          break
        case 'presentLineMissingLayer':
          this.showPresentLineMissingLayer = true
          break
        case 'presentLineDivided':
          this.showPresentLineDivided = true
          break
        default:
          console.warn('PresentSelector: props 傳入的options 對應失敗!', option)
      }
    })

    this.present.presentMissing = this.presentMissing
    this.present.presentLine = this.presentLine
    this.present.presentLineMissingLayer = this.presentLineMissingLayer
    this.present.presentLineDivided = this.presentLineDivided
  }
}
</script>
